import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { post } from '../api';

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  const [status, setStatus] = useState<'loading' | 'success' | 'error'>(
    'loading'
  );
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setError('This verification link is missing or invalid.');
      return;
    }
    post('auth/verify-email', { token })
      .then(() => setStatus('success'))
      .catch((e: any) => {
        setStatus('error');
        setError(e?.response?.data?.message || 'Invalid or expired link.');
      });
  }, [token]);

  return (
    <div className="columns">
      <div className="column is-half is-offset-one-quarter has-text-centered">
        {status === 'loading' && <p>Verifying your email...</p>}
        {status === 'success' && (
          <>
            <h2 className="title is-4">Email verified</h2>
            <p>Your email address has been confirmed.</p>
            <p className="mt-4">
              <Link to="/account">Back to my account</Link>
            </p>
          </>
        )}
        {status === 'error' && (
          <>
            <h2 className="title is-4">Verification failed</h2>
            <p>{error}</p>
            <p className="mt-4">
              <Link to="/account">Back to my account</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
